export default __webpack_public_path__ + "static/Chevrolet Lacetti-caded0fc7871c6bd4f3fd955b8120dbf.jpg";